"use client";
import { useMemo } from "react";
import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { getCrossSellProductIds } from "./cross-sell-functions";

/**
 * Every product id currently in the cart, as `/products/cross-sell` wants them.
 *
 * The endpoint can resolve the basket itself from the `Agent-Id` header when
 * `ids` is omitted, but we send them explicitly so the request describes exactly
 * the basket the shopper is looking at — the same contract the previous flow
 * used — rather than depending on the server and the client agreeing about whose
 * cart it is.
 */
export const useCartCrossSellIds = (): string => {
  const { data: cartData } = useGetCartQuery();
  const items = cartData?.result?.items;
  return useMemo(() => getCrossSellProductIds(items), [items]);
};
